import React from "react";
import { isIE, isSafari } from 'react-device-detect';
import { injectIntl } from "react-intl";
import MediaQuery from 'react-responsive';
import * as paths from '@app/constants/paths';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";

import FeatureCard from "@app/components/CustomCards/FeatureCard";
// IMG
// Mobile
import mobileSMwebp from "@app/assets/img/mocks/local-pro-mobile-mock-320w.webp";
import mobileSMjp2 from "@app/assets/img/mocks/local-pro-mobile-mock-320w.jp2";
import mobileMDwebp from "@app/assets/img/mocks/local-pro-mobile-mock-420w.webp";
import mobileMDjp2 from "@app/assets/img/mocks/local-pro-mobile-mock-420w.jp2";
import mobileLGwebp from "@app/assets/img/mocks/local-pro-mobile-mock-620w.webp";
import mobileLGjp2 from "@app/assets/img/mocks/local-pro-mobile-mock-620w.jp2";
import mobileXLwebp from "@app/assets/img/mocks/local-pro-mobile-mock-800w.webp";
import mobileXLjp2 from "@app/assets/img/mocks/local-pro-mobile-mock-800w.jp2";
import mobileXXLwebp from "@app/assets/img/mocks/local-pro-mobile-mock-1080w.webp";
import mobileXXLjp2 from "@app/assets/img/mocks/local-pro-mobile-mock-1080w.jp2";

import invoice from "@app/assets/img/icons/invoice.svg";
import euro from "@app/assets/img/icons/euro.svg";
import fastEuro from "@app/assets/img/icons/euro-down.svg";
import competition from "@app/assets/img/icons/competition.svg";

import featuresStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/featuresStyle";

const Features = props => {
    const { classes } = props;

    const isWebpSupported = !(isIE || isSafari);
    const title = props.intl.formatMessage({ id: "features.headline" });
    const section1Title = props.intl.formatMessage({ id: "features.section.1.title" });
    const section1Description = props.intl.formatMessage({ id: "features.section.1.description" });
    const section1Citation = props.intl.formatMessage({ id: "features.section.1.citation" });
    const section2Title = props.intl.formatMessage({ id: "features.section.2.title" });
    const section2Description = props.intl.formatMessage({ id: "features.section.2.description" });
    const section2Citation = props.intl.formatMessage({ id: "features.section.2.citation" });
    const section3Title = props.intl.formatMessage({ id: "features.section.3.title" });
    const section3Description = props.intl.formatMessage({ id: "features.section.3.description" });
    const section4Title = props.intl.formatMessage({ id: "features.section.5.title" });
    const section4Description = props.intl.formatMessage({ id: "features.section.5.description" });
    const imgAlt = props.intl.formatMessage({ id: "features.section.image.alt" });

    return (
        <div className={classes.features4}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={10} 
                    className={
                    classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                    }
                >
                    <h2 className={classes.title}>
                        {title}
                    </h2>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={3} lg={3} className={classes.mlAuto}>
                    <FeatureCard
                        icon={euro}
                        title={section1Title}
                        description={section1Description}
                        citation={section1Citation}
                    />
                    <FeatureCard
                        icon={competition}
                        title={section3Title}
                        description={section3Description}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={3} lg={4}>
                    <div className={classes.phoneContainer}>
                        <MediaQuery query="(max-device-width: 9999px)">
                            <MediaQuery query="(max-device-width: 420px)">
                                <a href={paths.SIGN_UP_PROFESSIONAL}>
                                    <img src={isWebpSupported ? mobileSMwebp : mobileSMjp2} alt={imgAlt} />
                                </a>
                            </MediaQuery>
                            <MediaQuery query="(min-device-width: 421px) and (max-device-width: 720px)">
                                <a href={paths.SIGN_UP_PROFESSIONAL}>
                                    <img src={isWebpSupported ? mobileMDwebp : mobileMDjp2}  alt={imgAlt} />
                                </a>
                            </MediaQuery>
                            <MediaQuery query="(min-device-width: 721px) and (max-device-width: 1280px)">
                                <a href={paths.SIGN_UP_PROFESSIONAL}>
                                    <img src={isWebpSupported ? mobileLGwebp : mobileLGjp2}  alt={imgAlt} />
                                </a>
                            </MediaQuery>
                            <MediaQuery query="(min-device-width: 1281px) and (max-device-width: 1920px)">
                                <a href={paths.SIGN_UP_PROFESSIONAL}>
                                    <img src={isWebpSupported ? mobileXLwebp : mobileXLjp2}  alt={imgAlt} />
                                </a>
                            </MediaQuery>
                            <MediaQuery query="(min-device-width: 1921px)">
                                <a href={paths.SIGN_UP_PROFESSIONAL}>
                                    <img src={isWebpSupported ? mobileXXLwebp : mobileXXLjp2}  alt={imgAlt} />
                                </a>
                            </MediaQuery>
                        </MediaQuery>
                    </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={3} lg={3} className={classes.mrAuto}>
                    <FeatureCard
                        icon={fastEuro}
                        title={section2Title}
                        description={section2Description}
                        citation={section2Citation}
                    />
                    <FeatureCard
                        icon={invoice}
                        title={section4Title}
                        description={section4Description}
                    />
                </GridItem>
            </GridContainer>
        </div>
        );
    }
    
export default injectIntl(withStyles(featuresStyle)(Features));